import { useQuery } from '@tanstack/react-query';
import { fetchPhoto, type MediaItem, type PhotoData } from './api';
import { ReviewPanel } from './ReviewPanel';
import { SectionLayout } from './SectionLayout';
import { getSectionStatus, useRequestId } from './sectionHelpers';

const PHOTO_BLOCKS: { key: keyof PhotoData; title: string }[] = [
  { key: 'logo', title: 'Логотип' },
  { key: 'entrance_area', title: 'Входная зона' },
  { key: 'waiting_area', title: 'Зона ожидания' },
  { key: 'acceptance_area', title: 'Зона приемки' },
  { key: 'repair_area', title: 'Ремонтная зона' },
];

const fullUrl = (item: MediaItem) => item.src ?? item.url ?? item.thumb_200_200;

const Gallery = ({ items }: { items: MediaItem[] }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, marginBottom: 30 }}>
    {items.map((item, index) => (
      <a
        key={item.id ?? index}
        href={fullUrl(item)}
        target="_blank"
        rel="noopener noreferrer"
        style={{ width: 100, height: 100, border: '1px solid #eee', overflow: 'hidden' }}
      >
        <img src={item.thumb_200_200 ?? fullUrl(item)} alt="" style={{ width: '100%' }} />
      </a>
    ))}
  </div>
);

export const VerificationPhotoPage = () => {
  const requestId = useRequestId();
  const { data, isLoading, error } = useQuery({
    queryKey: ['verification', 'photo', requestId],
    queryFn: () => fetchPhoto(requestId),
  });
  const status = getSectionStatus(data?.status);

  return (
    <SectionLayout title="Фото/Видео" status={status} isLoading={isLoading} error={error}>
      {data && (
        <>
          {PHOTO_BLOCKS.map(({ key, title }) => (
            <div key={key}>
              <h3 style={{ fontSize: 18 }}>{title}</h3>
              <Gallery items={(data[key] as MediaItem[] | null | undefined) ?? []} />
            </div>
          ))}
          <h3 style={{ fontSize: 18 }}>Видео</h3>
          <ul>
            {(data.video ?? []).map((item, index) => (
              <li key={item.id ?? index}>
                <a href={fullUrl(item)} target="_blank" rel="noopener noreferrer">
                  {fullUrl(item)}
                </a>
              </li>
            ))}
          </ul>
          <ReviewPanel
            requestId={requestId}
            section="photo_video"
            status={status}
            initialRejectMessage={data.reject_message}
          />
        </>
      )}
    </SectionLayout>
  );
};
